import React, { useContext, useEffect } from 'react'
import { userManager } from 'auth/services/auth.service'
import { CircleSpinner, AuthContext } from 'shared/index'

function LogoutPage() {
	const { isAuthenticated } = useContext(AuthContext)
	useEffect(() => {
		isAuthenticated &&
			userManager.signoutRedirect({
				id_token_hint: sessionStorage.getItem('id_token'),
			})
		userManager.clearStaleState()
		// eslint-disable-next-line
	}, [])

	return (
		<div className="d-flex justify-content-center align-items-center vh-100 callback">
			<CircleSpinner />
		</div>
	)
}
export default LogoutPage
